module.exports = __webpack_public_path__ + "static/media/goblin_axe.e780b685.png";